"use client";

import { cn } from "@/lib/utils";
import useSignUp from "@app/_hooks/useSignUp";
import useTranslate from "@app/_hooks/useTranslate";
import WishlistPDPToggle from "@features/account/components/wishlist/WishlistPDPToggle";
import LoginButton from "@features/auth/components/LoginButton";
import useAuth from "@features/auth/hooks/useAuth";
import { Button } from "@ui/button";
import { ComponentProps } from "react";

type ProductMonitoringProps = {
  productKey: string;
  variantKey: string;
} & ComponentProps<"div">;

export default function ProductMonitoring({
  productKey,
  variantKey,
  className,
  children,
  ...props
}: ProductMonitoringProps) {
  const { user } = useAuth();
  const t = useTranslate();
  const {
    active,
    toggleNotification,
    loading: loadingNotification,
  } = useSignUp({
    productId: productKey,
    variantId: variantKey,
  });
  return (
    <div
      className={cn("@container/form flex flex-col gap-y-2", className)}
      {...props}
    >
      <div className="grid grid-cols-[1fr_auto] gap-x-2">
        {user ? (
          <Button
            type="button"
            disabled={loadingNotification}
            onClick={toggleNotification}
            className={cn(active && "border-0 bg-green-600 text-white")}
          >
            {active ? t("removeNotification") : t("monitorProduct")}
          </Button>
        ) : (
          <LoginButton
            variant="default"
            className="w-full"
            redirectOnSuccess={false}
          >
            {t("monitorProduct")}
          </LoginButton>
        )}
        <WishlistPDPToggle
          productId={productKey}
          variantId={variantKey ?? ""}
        />
      </div>
      {children}
    </div>
  );
}
